import { render, staticRenderFns } from "./graduationCeremony.vue?vue&type=template&id=c5ba13bc&"
import script from "./graduationCeremony.vue?vue&type=script&lang=js&"
export * from "./graduationCeremony.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports